import { render } from "./TrainDateHistoryDetailView.vue?vue&type=template&id=64591050&scoped=true"
import script from "./TrainDateHistoryDetailView.vue?vue&type=script&lang=js"
export * from "./TrainDateHistoryDetailView.vue?vue&type=script&lang=js"

import "./TrainDateHistoryDetailView.vue?vue&type=style&index=0&id=64591050&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64591050"]])

export default __exports__